import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=7c6dd8ae&"
import script from "./BaseText.vue?vue&type=script&lang=ts&"
export * from "./BaseText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports